import ManageUsers from '@/pages/user-setting/ManageUsers';
import NewUserActivationScreen from '@/pages/user-setting/NewUserActivationScreen';
import ResetPassword from '@/pages/user-setting/ResetPassword';

const userRoutes = [
  { path: 'invite-user', element: ManageUsers },
  { path: 'manageuser', element: ManageUsers },
  { path: 'user-activation/:token', element: NewUserActivationScreen },
  { path: 'reset-password/:token', element: ResetPassword },
];

export default userRoutes;
